
import React from 'react';
import { Row } from "react-bootstrap";
import VideoButton from './VideoButton/VideoButton';
import NeedsAnalysisButton from '../../Tools/NeedsAnalysis/NeedsAnalysisButton';
import CircleSection from '../../Helpers/Circles/CircleSection';
import './ProductSpecifications.scss';

function TextContent(props) {
  var header = props.header ? props.header : "Product Specifications";
  return (
    <div className="text-content w-100">
      <Row className="header">
        <h2>{header}</h2>
      </Row>
      {props.data.map((d, index) =>
        <Row key={index} className="spec">
          <h3>{d.title}</h3>
          <p>{d.text}</p>
        </Row>
      )}
      {!props.hideNeedsAnalysis && <Row className="button-row">
        <NeedsAnalysisButton minCoverageAmount={props.coverageAmount.min} maxCoverageAmount={props.coverageAmount.max} />
      </Row>
      }
    </div >
  );
};

export default function ProductSpecifications(props) {
  const data = [{
    image: props.data.image,
    textContent: <TextContent data={props.data.specs} coverageAmount={props.coverageAmount} hideNeedsAnalysis={props.data.hideNeedsAnalysis} header={props.data.header}/>,
    belowPic: props.data.hideVideoLink ? null : <VideoButton title={props.data.video.name} link={props.data.video.link} />
  }];

  return (
    <div className="product-specifications">
      <CircleSection data={data} reverse />
    </div>
  );
};


// WEBPACK FOOTER //
// ./src/components/LandingPages/ProductSpecifications/ProductSpecifications.js